import { ENV, isITAREnvironment } from 'constants/env';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

/**
 * Triggers Google Analytics event through GA4.
 */
export const triggerGATagEvent = (action: string, category: string, label: string) => {
  ReactGA.event({
    action,
    category,
    label,
  });
};

/**
 * Google Tag Manager through react-gtm-module package.
 */
export const initializeGoogleTagManager = () => {
  if (isITAREnvironment()) {
    if (ENV.VITE_GOOGLE_TAG_MANAGER_ID) {
      Sentry.captureException('Attempt to load Google Tag Manager in ITAR environment.');
    }
    return;
  }
  if (ENV.VITE_GOOGLE_TAG_MANAGER_ID) {
    const tagManagerArgs = {
      gtmId: ENV.VITE_GOOGLE_TAG_MANAGER_ID,
    };
    TagManager.initialize(tagManagerArgs);
  }
};
